import { render } from "./IbanValidator.vue?vue&type=template&id=7a876880"
import script from "./IbanValidator.vue?vue&type=script&lang=js"
export * from "./IbanValidator.vue?vue&type=script&lang=js"

import "./IbanValidator.vue?vue&type=style&index=0&id=7a876880&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__